export default __webpack_public_path__ + "static/media/certificado_uno.7dbeecd7.PNG";